import AuthApi from '@/services/api/auth-api'

const state = {
  profile: {}
};

const getters = {
  profile(state: { profile: any; }) {
    return state.profile;
  }
};

const actions = {
  FETCH_PROFILE(context: { commit: (arg0: string, arg1: any) => void; }) {
    AuthApi.fetchProfile().then((response) => {
      //console.log("Admin profile",response.data)
      context.commit('SET_PROFILE', response.data);
    });
  },
};

const mutations = {
  SET_PROFILE(state: { profile: any }, payload: any) {
    state.profile = payload;
  }
};

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
};
